// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3VKbu","imageUploader":"EGiftCard_imageUploader__36_MI"};